import { log as devLogger } from '../../common/devLogger';
import { setExtraContext } from '../../common/RavenWrapper';
const MAX_LINES = 100;
const SENTRY_DATA_KEY = 'ablyLogs';
export function createLogHandler() {
  const lines = [];
  return function logHandler(msg) {
    const timestamp = new Date().toISOString();
    lines.push([timestamp, msg]);
    if (lines.length > MAX_LINES) {
      lines.shift();
    }
    setExtraContext({
      [SENTRY_DATA_KEY]: lines
    });
    devLogger(msg);
  };
}